<template>
	<div>
		<ed-form :data="formData" :config="config" :response="response" :itens="exameItems">
			<div slot="form-footer">
				<ed-alert 
					class="text-left"
					v-if="ultima_revisao" 
					title="Última Revisão desse LTCAT" 
					type="warning"
				>
					<span slot="description">
						<span v-if="ultima_revisao.parent">
							{{ultima_revisao.parent.rev}} ({{ultima_revisao.parent.descricao}} em {{toDate(ultima_revisao.parent.data,true)}}) /
						</span>
						<span>
							{{ultima_revisao.rev}} ({{ultima_revisao.descricao}} em {{toDate(ultima_revisao.data,true)}})
						</span>
					</span>
				</ed-alert>
			</div>
		</ed-form>
	</div>
</template>

<script>

	import Rest from 'common/rest';
	import EdForm from 'common/form';
	import EdAlert from 'common/alert';
	import FormItems  from './_form/ltcat-cadastrar';

  	export default {
  		name:"ltcat-risco-cadastrar",
  		components: {EdForm,EdAlert},
		mixins:[Rest],
		watch: {
			'formData.id_emp'(){
				this.config.disabled.id_fdt = (this.formData.id_emp ? false : true);
				this.formData.id_fdt = null;
				this.formData.id_rev = null;
				this.ultima_revisao = null;
				this.getFdt();
			},
			'formData.id_fdt'(){
				this.config.disabled.id_rev = (this.formData.id_fdt ? false : true);
				this.config.disabled.id_tipo_ltcat = (this.formData.id_fdt ? false : true);
				this.config.disabled.id_tipo_revisao = (this.formData.id_fdt ? false : true);
				this.config.disabled.data = (this.formData.id_fdt ? false : true);
				this.config.disabled.obs = (this.formData.id_fdt ? false : true);
				this.formData.id_rev = null;
				this.ultima_revisao = null;
				this.getUltimaRevisao();
				this.getRevisaoPpra();
			},
			'formData.id_tipo_ltcat'(){
				this.config.hidden.id_rev = (this.formData.id_tipo_ltcat == 205 ? false : true);
				this.config.hidden.id_ltcat = (this.formData.id_tipo_ltcat == 206 ? false : true);
				this.formData.id_rev = null;
				this.formData.id_ltcat = null;
			},
		},
  		data () {
		   	return {
				config:{
					tipo:[1,203],
					tipo_exclude:[],
					hidden:{
						id_rev:true,
						id_ltcat:true
					},
					title:{
						ppra:'Empresa sem PPRA'
					},
					disabled:{
						id_fdt:true,
						data:true,
						obs:true,
						id_rev:true,
						id_tipo_ltcat:true,
						id_tipo_revisao:true
					},
					click:{
						save:this.salvar,
						id_emp:this.getEmpresa,
						id_fdt:this.getFdt,
						id_rev:this.getRevisaoPpra,
						id_ltcat:this.getLtcat
					},
					list:{
						id_emp:[],
						id_fdt:[],
						id_rev:[],
						id_ltcat:[]
					},
					loading:{
						save:false,
						data:false,
						id_emp:false,
						id_fdt:false,
						id_rev:false,
						id_ltcat:false
					},
					options:{
						data:{
							disabledDate:this.handlerDisableYesterdayDate
						}
					}
				},
		   		formData:{
					id:0,
					id_tipo_ltcat:228,
					id_tipo_revisao:2,
		   			id_emp:null,
					id_fdt:null,
					id_rev:null,
					id_ltcat:null,
					obs:null,
					data:this.toDate(null,true),
					ppra:0,
				},
				ultima_revisao:null,
				response:{},
				exameItems:[],
			}
		},

		mounted: function() {
			this.exameItems = FormItems;
			this.getEmpresa();
			this.getLtcat();
		},

		methods: {

			onChangeProprio: function(){
			},

			getEmpresa(search){

				this.config.loading.id_emp = true;
				this.config.list.id_emp = [];
				
				this.get('empresa',{search:search}).then((result)=>{
					result = result[0];

					this.config.loading.id_emp = false;

					if(result.status == 200){
						this.config.list.id_emp = result.data.data;
					}
				});
			},

			getFdt(search){

				if(!this.formData.id_emp)return;

				this.config.loading.id_fdt = true;
				this.config.list.id_fdt = [];
				
				this.get('/pcmso/fdt/'+this.formData.id_emp,{search:search}).then((result)=>{
					result = result[0];

					this.config.loading.id_fdt = false;

					if(result.status == 200){
						this.config.list.id_fdt = result.data.data;
					}
				});
			},

			getRevisaoPpra(search){

				if(!this.formData.id_emp || !this.formData.id_fdt)return;

				this.config.loading.id_rev = true;
				this.config.list.id_rev = [];
				
				this.get('/pcmso/revisao/'+this.formData.id_emp+'/'+this.formData.id_fdt,{search:search}).then((result)=>{
					result = result[0];

					this.config.loading.id_rev = false;

					if(result.status == 200){
						this.config.list.id_rev = this.formataRevisao(result.data.data);
					}
				});
			},

			getLtcat(search){

				this.config.loading.id_ltcat = true;
				this.config.list.id_ltcat = [];
				
				this.get('/ltcat',{search:search}).then((result)=>{
					result = result[0];

					this.config.loading.id_ltcat = false;

					if(result.status == 200){
						this.config.list.id_ltcat = this.formataRevisao(result.data.data);
					}
				});
			},

			getUltimaRevisao(){

				if(!this.formData.id_emp || !this.formData.id_fdt)return;

				this.config.loading.data = true;
				this.ultima_revisao = null;
				
				this.get('/ltcat/ultima-revisao/'+this.formData.id_fdt).then((result)=>{
					result = result[0];

					this.config.loading.data = false;

					if(result.status == 200 && result.data){
						this.ultima_revisao  = result.data;
					}
					this.handlerValidarTipoRevisao();
				});
			},

			handlerValidarTipoRevisao(){

				if(this.ultima_revisao){
					var diff = this.diffDays(this.toDate(null,true,'YYYY-MM-DD'),this.ultima_revisao.data,'y');

					this.config.tipo_exclude = [2];
					this.formData.id_tipo_revisao = (diff>1 ? 4 : 3);
				}
				else{
					this.config.tipo_exclude = [3,4];
					this.formData.id_tipo_revisao = 2;
				}
			},

			handlerDisableYesterdayDate(date){

				if(!this.ultima_revisao)return false;

				var hoje = (this.ultima_revisao.parent ? this.ultima_revisao.parent.data : this.ultima_revisao.data);
				date = this.toDate(date,true,'YYYY-MM-DD');
				
				return date < hoje
			},

			salvar(){

				this.response = {};
				this.config.loading.save = true;

				this.post('ltcat/cadastrar',this.formData).then((result)=>{

					result = result[0];

					this.config.loading.save = false;
					this.response = result;

					if(result.status == 200){
						this.edMsg('Registro salvo com sucesso!');
						this.toRoute({name:'ltcat.editar',params:{id:result.data.id}});
					}

				});
			}
		}
  	}
</script>


// WEBPACK FOOTER //
// cadastrar.vue?77fe1a88